module.exports = __webpack_public_path__ + "3278fa48e19c30514d77358bef81a182.MP3";